import { render, staticRenderFns } from "./AcademicProgressDiscussion.vue?vue&type=template&id=56a16920&scoped=true"
import script from "./AcademicProgressDiscussion.vue?vue&type=script&lang=js"
export * from "./AcademicProgressDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a16920",
  null
  
)

export default component.exports